export const BARCODE_FORMAT = 'CODE128B'
